module.exports = "<div class=gmc-accordion-tab-header ng-click=$ctrl.toggleTab() ng-class=\"{active: $ctrl.isActive}\" ng-transclude=tabHeader><i class=\"gmc-accordion-tab-header__arrow material-icons\">arrow_drop_down</i>{{$ctrl.tabName}}</div><div class=gmc-accordion-tab-content gmc-collapse={{!$ctrl.isActive}} ng-transclude></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-accordion/components/gmc-accordion-tab/gmc-accordion-tab.component.html
// module id = 543
// module chunks = 31